<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<mat-dialog-content *ngIf="form" [formGroup]="form">
  <div class="control-item-component">
    <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;">
      {{ implementationControlStatementSet.id ? 'Edit' : 'Create' }}
      Implementation Control Statement Set
    </h2>
    <div [formGroup]="form">
      <div style="display: flex; flex-direction: row; justify-content: start; align-items: start; margin: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%;"
           >
        <div style="flex:100%">
          <mat-form-field class="example-full-width" style="width: 90%;">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name">
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="onSave()" style="border-radius: 6px;">Save</button>
  <button mat-raised-button style="border-radius: 6px;" (click)="onClose()">Cancel</button>
</mat-dialog-actions>
